import React from "react";
import { SubscriptionModal } from "../common/Subscription/SubscriptionModal";
import { CloseIcon } from "../../assets/icons";
import UpgradeIcon from "../../assets/icons/Upgrade";
import RocketIcon from "../../assets/icons/Rocket";
import PadLock from "../../assets/icons/PadLock";

interface IModalProps {
  onClose: () => void;
  moduleName: string | null;
  handleClick: () => void;
}
export const LevelUpBanner = ({
  onClose,
  moduleName,
  handleClick,
}: IModalProps) => {
  return (
    <SubscriptionModal>
      <div
        style={{
          background:
            "linear-gradient(180deg, #B0D6FB 0%, #F2F9FF 44.8%, #FFFFFF 100%)",
        }}
        className="max-w-[400px] text-[#212121] pl-[16px] pr-[12px]  rounded-[8px] py-[16px] shadow-xl"
      >
        <div className="flex items-center justify-end">
          <button onClick={onClose}>
            <CloseIcon width="24" height="24" />
          </button>
        </div>

        <div className="flex flex-col justify-center items-center gap-2">
          <div className="my-2">
            <UpgradeIcon />
          </div>

          <p className="text-xl font-semibold"> Level Up Your Buiness</p>
          <p className="text-center">
            Unlock{" "}
            <span className="font-semibold capitalize">{moduleName}</span> to
            help you get your business to the next level.
          </p>
        </div>

        <button
          onClick={handleClick}
          className="py-3 w-full text-[#ffffff] text-[14px] font-semibold mt-4 bg-[#044E97] rounded-[4px] text-center"
        >
          Upgrade now!
        </button>
        <a
          href="https://esemie.io/pricings/"
          target="_blank"
          className="py-3 w-full text-[#344054] text-[14px] font-semibold mt-1 rounded-[4px] flex justify-center text-center mx-auto"
        >
          Learn more
        </a>
      </div>
    </SubscriptionModal>
  );
};
export const LevelUpInfo = ({
  onClose,
  moduleName,
  handleClick,
}: IModalProps) => {
  return (
    <div className="text-[#212121] bg-[#E0EEFE] py-3  rounded-[8px] px-5 ">
      <div className="flex flex-col justify-center  gap-2">
        <div className="flex items-center gap-2">
          <PadLock color="black" />
          <p className="md:text-[17px] text-[16px] font-semibold">
             Level Up Your Buiness
          </p>
        </div>
        <p className="md:text-base text-basm text-[#344054]">
          Unlock <span className="font-semibold capitalize">{moduleName}</span>{" "}
          to help you get your business to the next level.
        </p>

        <button
          onClick={handleClick}
          className="w-full text-[#044E97] underline md:text-[15px] text-[14px] font-semibold rounded-[4px] text-left"
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};
export const ReachedLimitBanner = ({
  onClose,
  moduleName,
  handleClick,
}: IModalProps) => {
  return (
    <SubscriptionModal>
      <div
        style={{
          background:
            "linear-gradient(180deg, #B0D6FB 0%, #F2F9FF 44.8%, #FFFFFF 100%)",
        }}
        className="max-w-[400px] text-[#212121] pl-[16px] pr-[12px]  rounded-[8px] py-[16px] shadow-xl"
      >
        <div className="flex items-center justify-end">
          <button onClick={onClose}>
            <CloseIcon width="24" height="24" />
          </button>
        </div>

        <div className="flex flex-col justify-center items-center gap-2">
          <div className="my-2">
            <RocketIcon />
          </div>

          <p className="text-xl font-semibold">
             You’ve Reached Your Plan Limit
          </p>
          <p className="text-center">
            You've used all your{" "}
            <span className="font-semibold capitalize">{moduleName}</span>{" "}
            allocations. Upgrade your plan for more!
          </p>
        </div>

        <button
          onClick={handleClick}
          className="py-3 w-full text-[#ffffff] text-[14px] font-semibold mt-4 bg-[#044E97] rounded-[4px] text-center"
        >
          Renew your plan
        </button>
        <a href="https://esemie.io/pricings/" target="_blank" className="py-3 w-full text-[#344054] text-[14px] font-semibold mt-1 rounded-[4px] flex justify-center text-center mx-auto">
          Learn more
        </a>
      </div>
    </SubscriptionModal>
  );
};
export const SubscriptionExpired = ({
  onClose,
  moduleName,
  handleClick,
}: IModalProps) => {
  return (
    <SubscriptionModal>
      <div
        style={{
          background:
            "linear-gradient(180deg, #B0D6FB 0%, #F2F9FF 44.8%, #FFFFFF 100%)",
        }}
        className="max-w-[400px] text-[#212121] pl-[16px] pr-[12px]  rounded-[8px] py-[16px] shadow-xl"
      >
        <div className="flex items-center justify-end">
          <button onClick={onClose}>
            <CloseIcon width="24" height="24" />
          </button>
        </div>

        <div className="flex flex-col justify-center items-center gap-2">
          <div className="my-2">
            <RocketIcon />
          </div>

          <p className="text-xl font-semibold">
             Your Subscription Has Expired
          </p>
          <p className="text-center">
            Renew today to regain access and keep enjoying{" "}
            <span className="font-medium">{moduleName}</span>.
          </p>
        </div>

        <button
          onClick={handleClick}
          className="py-3 w-full text-[#ffffff] text-[14px] font-semibold mt-4 bg-[#044E97] rounded-[4px] text-center"
        >
          Renew your plan
        </button>
        <a href="https://esemie.io/pricings/" target="_blank" className="py-3 w-full text-[#344054] text-[14px] font-semibold mt-1 rounded-[4px] flex justify-center text-center mx-auto">
          Learn more
        </a>
      </div>
    </SubscriptionModal>
  );
};
